<template>
  <div class="pa-0 ma-0">
    <LoginForm mode="forgot" :response="message" v-on:form-submitted="reset">
      <template v-slot:buttons>
        <v-btn text color="primary" class="text-none" to="/login">Login</v-btn>
        <v-btn text color="primary" class="text-none" to="/register">Register</v-btn>
      </template>
    </LoginForm>
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card>
        <v-card-title class="headline">Password Reset</v-card-title>
        <v-card-text>Please check your email for details on your request.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text to="/login">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'ResetPassword',
  components: { LoginForm },
  data: () => ({
    dialog: false,
    message: {
      content: '',
      color: 'black',
    },
  }),
  computed: {
    modeTitle() {
      return this.modeOptions[this.mode] || '';
    },
  },
  methods: {
    reset(data) {
      const url = 'https://portal.beyondlabz.com/auth/reset/request';
      console.log('Reset password', url, data);
      this.$http
        .post(url, data)
        .then((resp) => {
          if (resp.status === 200) {
            if (typeof resp.data !== 'undefined') {
              this.dialog = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
